// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

function GoogleBusinessPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState('profile');
  const [profile, setProfile] = useState({ name: 'My Business', category: 'Professional Services', address: '121 Rainbow Falls Bay, Chestermere, AB', phone: '(403) 555-0100', website: 'mybusiness.pages.dev', hours: 'Mon-Fri 9-5', description: 'Professional services for businesses in Alberta and beyond.' });

  const insights = [
    { label: 'Profile Views', value: '2,840', change: '+18%', color: '#6366f1' },
    { label: 'Search Appearances', value: '5,120', change: '+12%', color: '#3b82f6' },
    { label: 'Phone Calls', value: '89', change: '+24%', color: '#10b981' },
    { label: 'Direction Requests', value: '142', change: '+8%', color: '#f59e0b' },
    { label: 'Website Clicks', value: '324', change: '+15%', color: '#8b5cf6' },
    { label: 'Photo Views', value: '1,280', change: '+22%', color: '#ec4899' },
  ];

  const posts = [
    { id: 1, type: 'Update', text: 'We\'re excited to announce new services for Q2 2026!', date: 'Feb 18', views: 245 },
    { id: 2, type: 'Offer', text: '20% off initial consultation for new clients this month.', date: 'Feb 12', views: 412 },
    { id: 3, type: 'Event', text: 'Join us for our free business workshop on March 5th.', date: 'Feb 8', views: 189 },
  ];

  const questions = [
    { q: 'Do you offer virtual consultations?', a: 'Yes, we offer both in-person and virtual consultations via Zoom.', date: 'Feb 15' },
    { q: 'Is parking available?', a: 'Yes, free parking is available on-site.', date: 'Feb 10' },
    { q: 'What industries do you serve?', a: '', date: 'Feb 19' },
  ];

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>{'\uD83D\uDCCD'} Google Business</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 15 }}>Manage your Google Business Profile and local presence.</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 12, marginBottom: 24 }}>
        {insights.map(s => (
          <div key={s.label} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 16 }}>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 2 }}>{s.label}</p>
            <p style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</p>
            <p style={{ fontSize: 11, color: '#10b981' }}>{s.change}</p>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {['profile', 'posts', 'questions', 'photos'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 20px', background: tab === t ? '#6366f1' : 'var(--card)', color: tab === t ? '#fff' : 'var(--text-muted)', border: tab === t ? 'none' : '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', textTransform: 'capitalize' }}>{t === 'questions' ? 'Q&A' : t}</button>
        ))}
      </div>
      {tab === 'profile' && (
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 24 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--text)', marginBottom: 20 }}>Business Information</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            {Object.entries(profile).map(([key, val]) => (
              <div key={key}><label style={labelStyle}>{key.charAt(0).toUpperCase() + key.slice(1)}</label><input type="text" value={val} onChange={e => setProfile(p => ({ ...p, [key]: e.target.value }))} style={inputStyle} /></div>
            ))}
          </div>
          <button style={{ padding: '10px 24px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>Update Profile</button>
        </div>
      )}
      {tab === 'posts' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, color: 'var(--text)' }}>Google Posts</h2>
            <button style={{ padding: '8px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>+ Create Post</button>
          </div>
          <div style={{ display: 'grid', gap: 10 }}>
            {posts.map(p => (
              <div key={p.id} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
                <span style={{ fontSize: 12, padding: '4px 10px', background: p.type === 'Offer' ? 'rgba(16,185,129,0.1)' : p.type === 'Event' ? 'rgba(99,102,241,0.1)' : 'rgba(59,130,246,0.1)', color: p.type === 'Offer' ? '#10b981' : p.type === 'Event' ? '#6366f1' : '#3b82f6', borderRadius: 6, fontWeight: 500 }}>{p.type}</span>
                <div style={{ flex: 1 }}><p style={{ fontSize: 14, color: 'var(--text)' }}>{p.text}</p></div>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{p.views} views</span>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{p.date}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {tab === 'questions' && (
        <div style={{ display: 'grid', gap: 10 }}>
          {questions.map((q, i) => (
            <div key={i} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 16 }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 6 }}>Q: {q.q}</p>
              {q.a ? (
                <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>A: {q.a}</p>
              ) : (
                <div style={{ display: 'flex', gap: 8 }}>
                  <input type="text" placeholder="Type your answer..." style={{ ...inputStyle, flex: 1 }} />
                  <button style={{ padding: '8px 16px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Answer</button>
                  <button style={{ padding: '8px 16px', background: 'rgba(99,102,241,0.1)', color: '#6366f1', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>{'\u2728'} AI</button>
                </div>
              )}
              <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>{q.date}</p>
            </div>
          ))}
        </div>
      )}
      {tab === 'photos' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
            {['Logo', 'Cover Photo', 'Office Interior', 'Team Photo'].map((label, i) => (
              <div key={i} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                <div style={{ height: 140, background: `linear-gradient(135deg, hsl(${i * 60}, 70%, 50%), hsl(${i * 60 + 40}, 70%, 40%))`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 500 }}>{label}</div>
                <div style={{ padding: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 13, color: 'var(--text)' }}>{label}</span>
                  <button style={{ padding: '4px 10px', background: 'transparent', color: '#6366f1', border: '1px solid #6366f1', borderRadius: 4, fontSize: 11, cursor: 'pointer' }}>Replace</button>
                </div>
              </div>
            ))}
            <div style={{ border: '2px dashed var(--border)', borderRadius: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40, cursor: 'pointer' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>{'\u2795'}</div>
              <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>Upload Photo</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 };
const inputStyle = { width: '100%', padding: '10px 14px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', fontSize: 14, outline: 'none', boxSizing: 'border-box' };

export default GoogleBusinessPage;
